export const SET_PLANS_SELECTION = 'SET_PLANS_SELECTION'
export const SET_PLANS_SELECTION_ELIGIBILITY = 'SET_PLANS_SELECTION_ELIGIBILITY'
export const SET_PLAN_CHANGE_SELECTED = 'SET_PLAN_CHANGE_SELECTED'
export const DELETE_PLANS_SELECTION = 'DELETE_PLANS_SELECTION'

export function setPlansSelection (data, processing = false) {
  return {
    type: SET_PLANS_SELECTION,
    payload: { data, processing },
  }
}

/**
 * Merge GraphQL plan eligibility onto the current plans selection (checkout / change-plan).
 * @param {object} payload - { sku, eligibility }; sku must match selection (reducer guard).
 */
export function setPlansSelectionEligibility (payload) {
  return {
    type: SET_PLANS_SELECTION_ELIGIBILITY,
    payload,
  }
}

export function deletePlansSelection () {
  return {
    type: DELETE_PLANS_SELECTION,
  }
}

export function setPlanChangeSelected (data) {
  return {
    type: SET_PLAN_CHANGE_SELECTED,
    payload: data,
  }
}
